export default {
  wrapper: {
    borderRadius: '4px',
    backgroundColor: '#EAECF0',
    height: '8px',
    overflow: 'hidden',
  },
  progress: {
    backgroundColor: '#273D37',
    height: '100%',
    borderRadius: '4px',
  },
};
